import _ from 'lodash'
// $render('Hello, ${ user }')
var $render = _.template;

var lookup = {
    de: {
        'greet': $render('Hallo, ${ user }'),
        'applicants': 'Bewerber',
        'employers': 'Steuerberater',
        'notifications': 'Mitteilungen',
        'Applicant': 'Bewerber',
        'Employer': 'Steuerberater',

        'phone': 'Tel:',
        'mail': 'Mail:',
        'address': 'Adresse:',
    },
}

function translate(key, data) {
    var val = lookup.de[key];
    if (typeof(val) === 'function') {
        return val(data);
    }
    return val;
}

export default translate



// WEBPACK FOOTER //
// ./src/utils/translate.js